<template>
  <div class="pie-chart">
    <div class="pie-chart-title">
      <span class="pie-chart-title-text">
        {{ title }}
      </span>
    </div>
    <div
      :id="`pie-chart-${name}`"
      style="width: 100%; height: 90%; overflow: hidden"
    ></div>
  </div>
</template>
<script setup>
import { ref, defineProps, onMounted } from "vue";
import * as echarts from "echarts";
const data = defineProps({
  name: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  data: {
    type: Array,
    default: () => [],
  },
});
onMounted(() => {
  setChart();
});
const setChart = () => {
  const chart = echarts.init(document.getElementById(`pie-chart-${data.name}`));
  chart.setOption({
    tooltip: {
      trigger: "item",
    },
    // 图例
    legend: {
      show: true,
      orient: "vertical",
      // left: "left",
      right: "10%",
      top: "center",
      itemWidth: 10,
      itemHeight: 10,
      itemGap: 10,
      textStyle: {
        fontSize: 12,
        color: "#fff",
      },
      // 截取文字
      formatter: (name) => {
        return name.length > 15 ? name.slice(0, 15) + "..." : name;
      },
    },
    series: [
      {
        name: "不良事件占比",
        type: "pie",
        radius: "50%",
        data: data.data,
        center: ["20%", "40%"],
        height: "140%",
        label: {
          show: false,
          formatter: "{b}: {c} ({d}%)",
        },
        labelLine: {
          show: true,
        },
      },
    ],
  });
};
</script>
<style scoped lang="less">
@import "@/assets/css/global.less";
.pie-chart {
  height: 100%;
  background-color: @card-background-color;
  border-radius: 8px;
  padding: 16px;
  .pie-chart-title {
    font-size: 18px;
    color: @text-color-secondary;
    text-align: left;
  }
}
</style>
